module.exports = __webpack_public_path__ + "static/constellations-overview-4cf2da14b0360cb5dd76352f88d6793a.jpg";